module.exports = __webpack_public_path__ + "static/media/TRIAL 1.bc324774.mp3";